import { useMemo } from 'react';
import { sortOptionsByValue } from '../helpers/sortOptions';
import { OneWayInOpportunitySimpleV2Dto } from 'src/api/v2';

const useDeliveredServices = (opportunities: OneWayInOpportunitySimpleV2Dto[]) => {
  const deliveredServicesOptions = useMemo(() => {
    const deliveredServices = opportunities
      .flatMap((opportunity) => opportunity?.deliveredServices || [])
      .filter(
        (service): service is { name: string; id: string } =>
          service.name !== undefined && service.id !== undefined,
      );

    // Remove duplicates based on ID
    const uniqueServices = deliveredServices.filter(
      (service, index, array) => array.findIndex((s) => s.id === service.id) === index,
    );

    const serviceOptions = uniqueServices.map((service) => ({
      label: service.name,
      value: service.id,
    }));

    return sortOptionsByValue(serviceOptions);
  }, [opportunities]);

  return { deliveredServicesOptions };
};

export default useDeliveredServices;
